import NavBar from "./Navbar/NavBar";

export const PageLayout = (props) => {
    return (
        <>
            <NavBar />
            {props.children}
        </>
    );
};